<div class="phone-field" [formGroup]="internal">

  <mat-form-field appearance="outline" class="phone-field__country">
    <mat-select formControlName="country" (blur)="onBlur()">
      <mat-select-trigger>
        {{ countryMap.get(internal.controls.country.value)?.flag }}
        +{{ countryMap.get(internal.controls.country.value)?.dialCode }}
      </mat-select-trigger>
      @for (c of countries; track c.code) {
        <mat-option [value]="c.code">{{ c.flag }} {{ c.name }} (+{{ c.dialCode }})</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="phone-field__number">
    <input
      matInput
      type="tel"
      formControlName="number"
      placeholder="82 123 4567"
      autocomplete="tel-national"
      (blur)="onBlur()"
    />
    <mat-hint>Optional — select country then enter number</mat-hint>
    <mat-error>Enter a valid number for the selected country</mat-error>
  </mat-form-field>

</div>